import type { ReactNode } from 'react';

export type PermissionGateProps = Readonly<{
  permission: string;
  permissions: readonly string[];
  children: ReactNode;
  fallback?: ReactNode;
}>;

export function PermissionGate({
  permission,
  permissions,
  children,
  fallback = null,
}: PermissionGateProps) {
  return permissions.includes(permission) ? <>{children}</> : <>{fallback}</>;
}
